"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InchcapeViewEvents = void 0;
/**
 * Events fired by the widget.
 */
var InchcapeViewEvents;
(function (InchcapeViewEvents) {
    InchcapeViewEvents["VALUATION_LOADED"] = "valuation:loaded";
})(InchcapeViewEvents = exports.InchcapeViewEvents || (exports.InchcapeViewEvents = {}));
